import { gql } from "@grandvisionhq/graphql";
import { createApplePaySessionResult } from "../../../fragments/operations/fragments/create-apple-pay-session-mutation-result.js";
const CREATE_APPLE_PAY_SESSION = gql`
  mutation CreateApplePaySession($applePaySessionInput: CreateApplePaySessionInput!) {
    createApplePaySession(input: $applePaySessionInput) {
      ...CreateApplePaySessionResultFragment
    }
  }
  ${createApplePaySessionResult}
`;
export {
  CREATE_APPLE_PAY_SESSION
};
//# sourceMappingURL=create-apple-pay-session.js.map
